import type { PrototypeProjectDetail } from '@/lib/prototype-catalog';

export interface CompareMatrixPayload {
  projects: Array<{ project_id: string; name: string }>;
  rows: Array<{ key?: string; label: string; values: readonly string[] }>;
}

/** Chat keeps a short ack — the full matrix lives on the board. */
export function chatReplyForCompare(fullReply: string): string {
  const trimmed = fullReply.trim();
  if (!trimmed) return 'Side-by-side comparison is on your board →';

  const tableStart = trimmed.search(/\*Side-by-side comparison\*/i);
  if (tableStart >= 0) {
    const lead = trimmed.slice(0, tableStart).trim();
    if (lead) return lead;
    return 'Side-by-side comparison is on your board →';
  }

  if (/\*Location\*|\*Starting price\*|\*Possession\*/i.test(trimmed)) {
    const beforeTable = trimmed.split(/\n\*Location\*/i)[0]?.trim();
    if (beforeTable) return beforeTable;
    return 'Side-by-side comparison is on your board →';
  }

  return trimmed;
}

export function buildCompareMatrixFromProjects(
  projects: PrototypeProjectDetail[],
): CompareMatrixPayload | null {
  const cols = projects.slice(0, 3);
  if (cols.length < 2) return null;

  return {
    projects: cols.map((p) => ({ project_id: p.id, name: p.name })),
    rows: [
      { label: 'Location', values: cols.map((p) => p.location || '—') },
      {
        label: 'Configurations',
        values: cols.map(
          (p) =>
            p.configurations?.map((c) => c.unitType).join(', ') ||
            p.bhk ||
            '—',
        ),
      },
      { label: 'Starting price', values: cols.map((p) => p.price || '—') },
      { label: 'Possession', values: cols.map((p) => p.possession || '—') },
      { label: 'Commute', values: cols.map((p) => p.commute || '—') },
      { label: 'Fit', values: cols.map((p) => p.fit || '—') },
    ],
  };
}
